import React from 'react';
import { ActivityIcon, AlertTriangleIcon, HeartCrackIcon, PillIcon, TimerIcon, TrendingDownIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { painPoints } from '../../data/content';
const icons = [ActivityIcon, TimerIcon, PillIcon, AlertTriangleIcon, TrendingDownIcon, HeartCrackIcon];
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-310" data-mp="2hk8aq355d1em">
      <div className="mx-auto max-w-5xl" data-id="element-311" data-mp="2hmb7r74pvusu">
        <div className="text-center" data-id="element-312" data-mp="2cm6nr74lohxv">
          <SectionLabel data-id="element-313" data-mp="2cl5f19b247jb">Ti suona familiare?</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl md:text-[42px]" data-id="element-314" data-mp="2qlg54a4jli3f">
            Ti capita di vivere una di queste situazioni durante la tua pratica?
          </h2>
        </div>

        <ul className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-315" data-mp="w7f8zx0dn971">
          {painPoints.map((point, index) => {
          const Icon = icons[index] ?? ActivityIcon;
          return <li key={point.id} className="flex flex-col rounded-2xl border border-navy-deep/10 bg-cream p-5 sm:p-6" data-id="element-316" data-mp="1n9msvoz2q5l7" data-mpi={index}>
                <Icon className="h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-317" data-mp="1x4y9ydxyfow4" />
                <h3 className="mt-3.5 text-[15px] font-extrabold uppercase leading-snug tracking-[0.02em] text-navy-deep sm:text-base" data-id="element-318" data-mp="21y0xo5g1w44e">
                  {point.title}
                </h3>
                <div className="mt-2.5 flex flex-col gap-2" data-id="element-319" data-mp="2avte5cxidhtd">
                  {point.lines.map(line => <p key={line} className="text-[14px] leading-relaxed text-navy/75" data-id="element-320" data-mp="2fuecf6t79rf6">
                      {line}
                    </p>)}
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-8 max-w-2xl rounded-2xl bg-navy-deep px-5 py-6 text-center sm:mt-12 sm:px-8 sm:py-8" data-id="element-321" data-mp="qjnaz3x19upy">
          <p className="text-[15px] font-semibold leading-relaxed text-white/85 sm:text-lg" data-id="element-322" data-mp="ef9lyjfgwlci">
            Se hai risposto “sì” anche solo a una…
          </p>
          <p className="mt-2 font-display text-[20px] font-bold leading-snug text-kidney-bright sm:text-2xl" data-id="element-323" data-mp="sgly0jric2t4">
            Percorso Malattia Renale™ è stato creato esattamente per te.
          </p>
        </div>
      </div>
    </section>;
}